import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44160b5c")

_pushScopeId("data-v-44160b5c")
const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("b", null, "Please correct the following error(s):", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("상품 정보 [")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("]")
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = {
  role: "group",
  class: "form-group"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", null, "서비스 구분", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = {
  role: "group",
  class: "form-group"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, "상품 카테고리", -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, "제품명", -1)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, "운영 시간", -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", null, "운영 시작 월일", -1)
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", null, "운영 종료 월일", -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", null, "가격", -1)
const _hoisted_36 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", null, "1인당 가격", -1)
const _hoisted_39 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", null, "독배 가격", -1)
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = { class: "card card-accent-primary form-group" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "대상어", -1)
const _hoisted_46 = { class: "card-body" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/_createVNode("label", null, "공지사항", -1)
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", null, "준비물 설명", -1)
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", null, "서비스 설명", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["card", {loading: _ctx.loading}]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.errors.length)
        ? (_openBlock(), _createBlock("p", _hoisted_2, [
            _hoisted_3,
            _createVNode("ul", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                return (_openBlock(), _createBlock("li", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("form", {
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h1", null, [
              _hoisted_6,
              _createVNode("a", {
                href: `/partners-member/edit/${_ctx.partners.data_id}?page=1`,
                class: "text-reset"
              }, _toDisplayString(_ctx.product.partners_name), 9, ["href"]),
              _hoisted_7
            ]),
            _hoisted_8
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.product.business_type_cd = $event)),
                      required: ""
                    }, [
                      _createVNode("option", {
                        value: _ctx.BusinessTypes.BOAT
                      }, "선상낚시", 8, ["value"]),
                      _createVNode("option", {
                        value: _ctx.BusinessTypes.SPOT
                      }, "낚시터", 8, ["value"])
                    ], 512), [
                      [_vModelSelect, _ctx.product.business_type_cd]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.product.product_category_cd = $event)),
                      required: ""
                    }, [
                      _createVNode("option", {
                        value: _ctx.PartnersProductCategoryTypes.BOATPRODUCT
                      }, "선박낚시", 8, ["value"]),
                      _createVNode("option", {
                        value: _ctx.PartnersProductCategoryTypes.ROCKPRODUCT
                      }, "갯바위", 8, ["value"]),
                      _createVNode("option", {
                        value: _ctx.PartnersProductCategoryTypes.TASTESOPT
                      }, "손맛터", 8, ["value"]),
                      _createVNode("option", {
                        value: _ctx.PartnersProductCategoryTypes.ETCFISHSPOT
                      }, "잡어터", 8, ["value"])
                    ], 512), [
                      [_vModelSelect, _ctx.product.product_category_cd]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.product.product_name = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.product.product_name]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.product.oper_hour = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.product.oper_hour]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.product.season_start_mm_dd = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.product.season_start_mm_dd]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.product.season_end_mm_dd = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.product.season_end_mm_dd]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              (_ctx.product.business_type_cd === _ctx.BusinessTypes.SPOT)
                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                    _createVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.product.price = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.product.price]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.product.business_type_cd === _ctx.BusinessTypes.BOAT)
                ? (_openBlock(), _createBlock("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.product.price_per_person = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.product.price_per_person]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.product.business_type_cd === _ctx.BusinessTypes.BOAT)
                ? (_openBlock(), _createBlock("div", _hoisted_39, [
                    _createVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.product.price_per_boat = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.product.price_per_boat]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode("div", _hoisted_46, [
                    _createVNode("div", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.product.productFish, (fish) => {
                        return (_openBlock(), _createBlock("span", {
                          class: "fs badge badge-pill badge-primary",
                          key: fish.data_id
                        }, _toDisplayString(fish.target_fish_nm), 1))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _hoisted_49,
              _withDirectives(_createVNode("textarea", {
                class: "form-control",
                rows: "12",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.product.noti = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.noti]
              ])
            ]),
            _createVNode("div", _hoisted_50, [
              _hoisted_51,
              _withDirectives(_createVNode("textarea", {
                class: "form-control",
                rows: "5",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.product.preparation = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.preparation]
              ])
            ]),
            _createVNode("div", _hoisted_52, [
              _hoisted_53,
              _withDirectives(_createVNode("textarea", {
                class: "form-control",
                rows: "5",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.product.service_desc = $event))
              }, null, 512), [
                [_vModelText, _ctx.product.service_desc]
              ])
            ])
          ])
        ])
      ], 32)
    ])
  ], 2))
})